<template>
    <div class="padding">
        <div class="flex flex-between flex-v-center" style="padding: 0 10px;">
            <h4>{{ $t('批改作业') }}</h4>
            <div class="flex flex-v-center" style="position: relative;top:40px">
                <el-input style="border-radius: 20px;" :placeholder="$t('请输入老师名称')" v-model="name">
                    <el-button slot="append" icon="el-icon-search"></el-button>
                </el-input>
            </div>
        </div>

        <div style="padding: 0 10px;" class="margin-t">
            <el-tabs v-model="status" @tab-click="getList()">
                <el-tab-pane :label="$t('待批改') + '(' + counts[0] + ')'" name="1"></el-tab-pane>
                <el-tab-pane :label="$t('已完成') + '(' + counts[1] + ')'" name="2"></el-tab-pane>
            </el-tabs>
        </div>

        <el-table v-loading="loading == 'list'"
            :header-cell-style="{ background: '#f5f7fa', color: '#333', 'border-radius': '4px' }" class="margin-t"
            :data="tableData" style="width: 100%">
            <el-empty slot="empty" :description="$t('还没有批改作业数据')" style="margin-top: 100px;"></el-empty>
            <el-table-column align="center" width="120px" prop="nickName" :label="$t('学生信息')">
            </el-table-column>

            <el-table-column align="center" width="120px" prop="name" :label="$t('批改老师')">
            </el-table-column>

            <el-table-column align="center" prop="clazz_name" :label="$t('班级名称')">
            </el-table-column>
            <el-table-column align="center" prop="title" :label="$t('作业标题')">
            </el-table-column>
            <el-table-column align="center" prop="user_time" :label="$t('提交时间')">
            </el-table-column>
            <el-table-column align="center" v-if="status == 2" prop="teacher_time" :label="$t('批改时间')">
            </el-table-column>

            <el-table-column prop="address" :label="$t('操作')" width="100px">
                <template slot-scope="scope">
                    <el-button size="mini" :loading="loading == 'open_' + scope.row.id" icon="el-icon-edit-outline"
                        type="primary" @click="open(scope.row)">{{
                            scope.row.status == 2 ? $t('查看') :
                                $t('批改')
                        }}</el-button>
                </template>
            </el-table-column>
        </el-table>



        <el-dialog fullscreen v-if="record" :visible.sync="dalogVisible" :close-on-click-modal="false"
            :show-close="false" width="50%" center>
            <h4 slot="title">{{ record.work.title }}</h4>

            <el-card shadow="never">
                <el-form ref="form" label-position="left" :model="form" label-width="120px">

                    <el-form-item prop="content">
                        <h4 slot="label">{{ $t('作业内容') }}</h4>
                        <div>{{ record.work.content }}</div>
                        <div v-for="(item1, i) in record.work.attachment" :key="i">
                            <el-divider></el-divider>
                            <div class="flex flex-between flex-v-center">
                                <audio controls v-if="item1.type == 'audio'" :src="$host + item1.url"></audio>
                                <el-image :preview-src-list="[$host + item1.url]" v-else-if="item1.type == 'image'"
                                    style="height: 100px;width: 200px;" fit="cover" :src="$host + item1.url"></el-image>
                                <el-link v-else-if="item1.type == 'file'">{{ item1.url.split('/').pop()
                                    }}</el-link>

                                <div class="flex flex-v-center">
                                    <el-tooltip :content="$t('下载')">
                                        <el-button @click="remove_attachment(i)" style="font-size: 25px;" type="text"
                                            icon="el-icon-download"></el-button>
                                    </el-tooltip>
                                </div>
                            </div>

                        </div>
                    </el-form-item>

                    <el-form-item prop="content">
                        <h4 slot="label">{{ $t('学生留言') }}</h4>
                        <el-input autosize readonly type="textarea" :placeholder="$t('请输入留言内容')"
                            v-model="record.content.text">
                        </el-input>

                        <div v-for="(item, i) in record.content.attachment" :key="i">
                            <el-divider></el-divider>
                            <div class="flex flex-between flex-v-center">
                                <audio v-if="item.type == 'audio'" controls :src="$host + item.url"></audio>
                                <el-image :preview-src-list="[$host + item.url]" v-else-if="item.type == 'image'"
                                    style="height: 100px;width: 200px;" fit="cover" :src="$host + item.url"></el-image>
                                <el-link v-else-if="item.type == 'file'">{{ item.url.split('/').pop()
                                    }}</el-link>

                                <div class="flex flex-v-center" v-if="record.status == 0">
                                    <el-tooltip :content="$t('下载')">
                                        <el-button @click="open_attachment(i)" style="font-size: 25px;" type="text"
                                            icon="el-icon-download"></el-button>
                                    </el-tooltip>
                                    <el-tooltip :content="$t('移除')">
                                        <el-button @click="remove_attachment(i)" style="font-size: 25px;" type="text"
                                            icon="el-icon-close"></el-button>
                                    </el-tooltip>
                                </div>
                            </div>

                        </div>

                    </el-form-item>

                    <el-divider></el-divider>
                    <el-form-item prop="content">
                        <h4 slot="label">{{ $t('学生作业') }}</h4>
                        <div v-if="record.records && record.records.length > 0">
                            <template v-for="(item, index) in record.records">
                                <record-list @review="handleReview" :homework-index="index" :key="item.id" teacher
                                    :tag="item.source.tag" :answer="item.source.answer" homework :list="[item]">

                                    <div slot="append" :key="item.id" v-if="item.result" class="margin-t padding"
                                        style="background-color: #f5f5f5;border-radius: 10px;">
                                        <div class="flex flex-v-center">
                                            <el-avatar :src="item.result.teacher.avatar"></el-avatar>

                                            <div class="margin-l" style="line-height:24px;">
                                                <h4>{{ item.result.teacher.name }}</h4>
                                                <div style="color:#999">{{ item.result.time }}</div>
                                            </div>
                                        </div>

                                        <div>
                                            <el-tag size="small">{{ item.result.pass ? $t('达标') : $t('不达标') }}</el-tag>
                                            <span class="margin-l">{{ item.result.content }}</span>
                                        </div>
                                        <div v-for="(item, i) in item.result.attachment" :key="i" class="margin-ts">
                                            <div class="flex flex-between flex-v-center">
                                                <audio v-if="item.type == 'audio'" controls
                                                    :src="$host + item.url"></audio>
                                                <el-image :preview-src-list="[$host + item.url]"
                                                    v-else-if="item.type == 'image'" style="height: 100px;width: 200px;"
                                                    fit="cover" :src="$host + item.url"></el-image>
                                                <el-link v-else-if="item.type == 'file'">{{
                                                    item.url.split('/').pop()
                                                }}</el-link>

                                                <div class="flex flex-v-center" v-if="record.status == 0">
                                                    <el-tooltip :content="$t('下载')">
                                                        <el-button @click="open_attachment(i)" style="font-size: 25px;"
                                                            type="text" icon="el-icon-download"></el-button>
                                                    </el-tooltip>
                                                    <el-tooltip :content="$t('移除')">
                                                        <el-button @click="remove_attachment(i)"
                                                            style="font-size: 25px;" type="text"
                                                            icon="el-icon-close"></el-button>
                                                    </el-tooltip>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </record-list>

                            </template>
                        </div>
                        <el-empty :description="$t('还没添加练习到作业中')" v-else></el-empty>
                    </el-form-item>
                </el-form>
            </el-card>


            <span class="dialog-footer center" slot="footer">
                <el-button icon="el-icon-close" @click="dalogVisible = false">{{ $t('关 闭') }}</el-button>
            </span>
        </el-dialog>

        <el-dialog append-to-body top="40px" @close="record_close" v-if="dalogVisible1" :visible.sync="dalogVisible1"
            :close-on-click-modal="false" :show-close="false" width="60%" center>
            <h4 slot="title">{{ record.title }}</h4>


            <el-card shadow="never">
                <h3 slot="header">{{ $t('老师批改') }}</h3>
                <el-form ref="form" label-position="top" :model="form" label-width="80px">
                    <el-form-item prop="title">
                        <el-switch v-model="form.pass" :inactive-text="$t('不达标')" :active-text="$t('达标')"></el-switch>
                    </el-form-item>

                    <el-form-item prop="content" :rules="[
                        { required: true, message: $t('评价内容不能为空') },
                    ]" :label="$t('评价内容')">
                        <el-input type="textarea" :rows="6" :placeholder="$t('请输入评价内容')" v-model="form.content">
                        </el-input>

                        <div v-for="(item, i) in form.attachment" :key="i">
                            <el-divider></el-divider>
                            <div class="flex flex-between flex-v-center">
                                <template v-if="item.type == 'audio'">
                                    <audio controls v-if="item.url" :src="$host + item.url"></audio>
                                    <audio-recorder v-else :index="i" @start="set_audio_index" @content="set_audio"
                                        :time_limit="120" :submittable="false"></audio-recorder>
                                </template>
                                <el-image :preview-src-list="[$host + item.url]" v-else-if="item.type == 'image'"
                                    style="height: 100px;width: 200px;" fit="cover" :src="$host + item.url"></el-image>
                                <el-link v-else-if="item.type == 'file'">{{ item.url.split('/').pop()
                                    }}</el-link>

                                <div class="flex flex-v-center">
                                    <el-tooltip :content="$t('下载')">
                                        <el-button @click="open_attachment(i)" style="font-size: 25px;" type="text"
                                            icon="el-icon-download"></el-button>
                                    </el-tooltip>
                                    <el-tooltip :content="$t('移除')">
                                        <el-button @click="remove_attachment(i)" style="font-size: 25px;" type="text"
                                            icon="el-icon-close"></el-button>
                                    </el-tooltip>
                                </div>
                            </div>

                        </div>

                        <div class="flex flex-v-center margin-ts">
                            <el-button style="font-size: 16px;" @click="add_audio()" type="text" size="large"
                                icon="el-icon-service">{{
                                    $t('添加音频') }}</el-button>

                            <el-divider class="margin-x" direction="vertical"></el-divider>
                            <el-upload accept="image/jpeg,image/jpg,image/png" :headers="headers" :action="action"
                                :show-file-list="false" :on-success="handleImageSuccess">
                                <el-button style="font-size: 16px;" type="text" size="large" icon="el-icon-picture">{{
                                    $t('添加图片') }}</el-button>
                            </el-upload>
                            <el-divider class="margin-x" direction="vertical"></el-divider>
                            <el-upload accept=".pdf,.doc,.docx,.xls,.xlsx" :headers="headers" :action="action"
                                :show-file-list="false" :on-success="handleFileSuccess">
                                <el-button style="font-size: 16px;" type="text" size="large"
                                    icon="el-icon-document-add">{{
                                        $t('添加文件') }}</el-button>
                            </el-upload>
                        </div>
                    </el-form-item>
                </el-form>
            </el-card>

            <span class="dialog-footer center" slot="footer">
                <el-button class="margin-r" @click="dalogVisible1 = false">{{ $t('关 闭') }}</el-button>

                <el-button class="margin-l" :loading="loading == 'submit'" type="primary" @click="submit()">{{
                    $t('提交批改')
                }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
import AudioRecorder from '@/components/AudioRecorder.vue';
import RecordList from '@/components/RecordList.vue';
import getWFD from '../../../util';

export default {
    components: { RecordList, AudioRecorder },

    data() {
        return {
            counts: [0, 0],
            action: 'https://www.ptefighter.com/api/work/upload',
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            name: '',
            status: '1',
            tableData: [],
            record: null,
            dalogVisible: false,
            dalogVisible1: false,
            form: { attachment: [], pass: false, content: '' },
            loading: null,
            audio_index: -1,
            delete_urls: [],
            record_id: 0,
        }
    },
    created() {
        this.get_counts();
        this.getList();
    },
    methods: {
        handleReview(id) {
            this.delete_urls = []
            this.record_id = id
            this.dalogVisible1 = true
        },

        get_counts() {
            this.$http.post("/api/work/counts").then((counts) => {
                this.counts = counts
            })
        },

        record_close() {
            if (this.form.attachment.length > 0) {
                const urls = this.form.attachment.filter(v => v.is_new).map(v => v.url)
                if (urls.length > 0) {
                    this.$http.post("/api/work/upload/remove", { urls })
                }
            }
        },

        set_audio_index(index) {
            this.audio_index = index
        },

        set_audio(file) {
            this.form.attachment[this.audio_index].file = file
        },

        add_audio() {
            this.form.attachment.push({
                type: 'audio'
            })
        },
        submit() {
            this.loading = "submit"
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    for (let i = 0; i < this.form.attachment.length; i++) {
                        if (this.form.attachment[i].file) {
                            let formData = new FormData();
                            formData.append("file", this.form.attachment[i].file);
                            const url = await this.$http.post('/api/work/upload', formData, {
                                timeout: 60000,
                                headers: {
                                    'Content-type': 'multipart/form-data'
                                }
                            })
                            this.form.attachment[i].url = url
                            delete this.form.attachment[i].file
                        }
                        delete this.form.attachment[i].is_new
                    }


                    this.$http.post('/api/work/record/result', { id: this.record.id, record_id: this.record_id, result: this.form }).then((status) => {
                        this.$message({
                            type: 'success',
                            message: this.$t("提交成功")
                        })
                        if (this.delete_urls.length > 0) {
                            this.$http('/api/work/upload/remove', { urls: this.delete_urls })
                        }
                        this.form.attachment = []
                        this.dalogVisible1 = false
                        if(status == 2){
                            this.get_counts()
                            this.getList()
                        }
                        this.$http.post("/api/homework/record/info", { id: this.record.id }).then((record) => {
                            if (record.records) {
                                record.records.forEach(item => {
                                    if (item.content == null) {
                                        item.content = "";
                                        item.height = 0;
                                    }
                                    if (item.content && item.source.tag == 'WFD') {
                                        item.contents = getWFD(item.source.answer, item.content);
                                    }
                                });
                            }
                            this.record = record;
                        })
                        this.loading = null
                    })
                } else {
                    this.loading = null
                    return false;
                }
            });
        },

        remove_attachment(i) {
            if (!this.form.attachment[i].url) {
                this.form.attachment.splice(i, 1)
                return
            }
            if (this.form.attachment[i].is_new) {
                const urls = [this.form.attachment[i].url]
                this.$http.post("/api/work/upload/remove", { urls }).then(() => {
                    this.form.attachment.splice(i, 1)
                })
            } else {
                this.delete_urls.push(this.form.attachment[i].url)
                this.form.attachment.splice(i, 1)
            }
        },

        handleAudioSuccess(url) {
            this.form.attachment.push({
                type: 'audio',
                url,
                is_new: true
            })
        },
        handleImageSuccess(url) {
            this.form.attachment.push({
                type: 'image',
                url,
                is_new: true
            })
        },
        handleFileSuccess(url) {
            this.form.attachment.push({
                type: 'file',
                url,
                is_new: true
            })
        },

        open(item) {
            this.loading = 'open_' + item.id
            
            this.$http.post("/api/homework/record/info", { id: item.id }).then((record) => {
                if (record.records) {
                    record.records.forEach(item => {
                        if (item.content == null) {
                            item.content = "";
                            item.height = 0;
                        }
                        if (item.content && item.source.tag == 'WFD') {
                            item.contents = getWFD(item.source.answer, item.content);
                        }
                    });
                }
                this.record = record;
                this.dalogVisible = true;
                this.loading = null
            })
        },
        getList() {
            this.loading = 'list'
            this.$http.post('/api/work/records', { status: this.status, name: this.name }).then(data => {
                this.tableData = data;
                this.loading = null
            });
        },
        to(path) {
            this.$router.push(path);
        }
    }
};
</script>
